import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { GlobalStateService } from 'src/app/services/global/global-state.service';
import { Proforma } from 'src/app/pages/sales/proforma/proforma.model';

declare var bootstrap: any;

@Component({
  selector: 'app-proforma-docs-release',
  templateUrl: './proforma-docs-release.component.html',
  styleUrls: ['./proforma-docs-release.component.scss']
})
export class ProformaDocsReleaseComponent extends DestructorComponent implements OnInit {

  @Output() formSubmitted = new EventEmitter<any>();

  docsReleaseForm: FormGroup;
  countries: any[] = [];
  selectedProforma: Proforma | null = null;
  formSubmittedFlag: boolean = false;

  constructor(
    private fb: FormBuilder,
    private _globalStateService: GlobalStateService
  ) {
    super();
    this.docsReleaseForm = this.initializeForm();
  }

  ngOnInit(): void {
    this.loadCountries();
    this.setupModalListener();
  }

  private initializeForm(): FormGroup {
    return this.fb.group({
      sameAsConsignee: [false],
      receiverName: ['', Validators.required],
      address: ['', Validators.required],
      postZipCode: [''],
      country: ['', Validators.required],
      city: ['', Validators.required],
      contactPerson: ['', Validators.required],
      phoneNo: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      remarks: ['', Validators.required]
    });
  }

  private setupModalListener(): void {
    const modalElement = document.getElementById('kt_modal_proforma_docs_release');
    if (modalElement) {
      modalElement.addEventListener('show.bs.modal', () => {
        const selectedProforma = (window as any).selectedProformaForDocsRelease;
        if (selectedProforma) {
          this.selectedProforma = selectedProforma;
        }
      });

      modalElement.addEventListener('hidden.bs.modal', () => {
        this.resetForm();
      });
    }
  }

  private loadCountries(): void {
    this.subscriptions.push(
      this._globalStateService.GetCountries().subscribe({
        next: (countries: any) => {
          if (countries && Array.isArray(countries)) {
            this.countries = countries;
          }
        },
        error: (error: any) => {
          console.error('Error loading countries:', error);
        }
      })
    );
  }

  onSameAsConsigneeChange(event: any): void {
    const isChecked = event.target.checked;
    if (isChecked && this.selectedProforma) {
      // Populate form fields from buyer/consignee data
      this.docsReleaseForm.patchValue({
        receiverName: this.selectedProforma.buyer_consignee_name || '',
        address: this.selectedProforma.buyer_street_address || '',
        postZipCode: '', // Not available in buyer data
        country: this.getCountryCode(this.selectedProforma.buyer_country) || '',
        city: this.selectedProforma.buyer_city || '',
        contactPerson: this.selectedProforma.buyer_consignee_name || '',
        phoneNo: this.selectedProforma.buyer_telephone_no || '',
        email: this.selectedProforma.buyer_email_address || '',
        remarks: ''
      });
    } else {
      // Clear the form if unchecked
      this.docsReleaseForm.patchValue({
        receiverName: '',
        address: '',
        postZipCode: '',
        country: '',
        city: '',
        contactPerson: '',
        phoneNo: '',
        email: '',
        remarks: ''
      });
    }
  }

  // Helper method to get country code from country name
  private getCountryCode(countryName: string | undefined): string {
    if (!countryName) return '';

    const country = this.countries.find(c =>
      c.name.toLowerCase() === countryName.toLowerCase()
    );
    return country ? country.code : '';
  }

  onSubmit(): void {
    this.formSubmittedFlag = true;

    if (this.docsReleaseForm.valid && this.selectedProforma) {
      const formData = {
        proformaId: this.selectedProforma._id,
        proforma: this.selectedProforma,
        ...this.docsReleaseForm.value
      };

      // Console log the form data as requested
      console.log('Docs Release Form Data:', formData);

      // Emit the form data
      this.formSubmitted.emit(formData);

      // Close the modal
      this.closeModal();
    }
  }

  private resetForm(): void {
    this.docsReleaseForm.reset();
    this.formSubmittedFlag = false;
    this.selectedProforma = null;
  }

  private closeModal(): void {
    const modalElement = document.getElementById('kt_modal_proforma_docs_release');
    if (modalElement) {
      const modal = bootstrap.Modal.getInstance(modalElement);
      if (modal) {
        modal.hide();
      }
    }
  }

  // Helper method to check if a field is invalid
  isFieldInvalid(fieldName: string): boolean {
    const field = this.docsReleaseForm.get(fieldName);
    return !!(field && field.invalid && (field.dirty || field.touched || this.formSubmittedFlag));
  }

}
